import SupportButton from "./supportButton";
import "./needHelp.scss";
import React from "react";
import ConfigPropService from "../../utilities/configPropService";
import ConfigProps from "../../constants/configProps";
import { wbmLiveChatBootstrapId } from "./liveChat";
import { Subscription } from "rxjs";
import { PhoneService } from "../../utilities/phoneService";
import NavigationTokensService from "../../utilities/navigationTokensService";
import NavigationTokens from "../../constants/navigationTokens";
import YourRepresentative, { RepTypes } from "../yourRepresentative/yourRepresentative";

const liveChatPortalId = "wbm-live-chat-portal";

export interface INeedHelpState {
  chatId: string;
  phone: string;
  navTokens: Record<string, string>;
}

class NeedHelp extends React.Component<unknown, INeedHelpState> {
  configPropSub: Subscription | undefined;
  navTokenSub: Subscription | undefined;

  constructor(props: unknown) {
    super(props);

    this.state = {
      phone: "",
      chatId: "",
      navTokens: {},
    };
  }

  moveChatElement() {
    // live chat is bootstrapped during the DOMContentLoaded event
    // instead of creating the live chat element in this component
    // it is handled by the LiveChat component and manually moved
    // when the component unmounts it is moved back
    const element = document.getElementById(this.state.chatId);

    if (element) {
      const portalElement = document.getElementById(liveChatPortalId);
      if (portalElement) {
        portalElement.appendChild(element);
      }
    }
  }

  componentWillUnmount() {
    // reset chat element
    const element = document.getElementById(this.state.chatId);

    if (element) {
      const bootstrapElement = document.getElementById(wbmLiveChatBootstrapId);
      if (bootstrapElement) {
        bootstrapElement.appendChild(element);
      }
    }

    if (this.configPropSub) {
      this.configPropSub.unsubscribe();
    }
    if (this.navTokenSub) {
      this.navTokenSub.unsubscribe();
    }
  }

  componentDidMount() {
    this.configPropSub = ConfigPropService.get([
      ConfigProps.CustomerServicePhoneNumber,
      ConfigProps.HeaderEmbeddedWebChatID,
    ]).subscribe((configProps) => {
      this.setState(
        {
          phone: PhoneService.normalizePhone(
            configProps[ConfigProps.CustomerServicePhoneNumber]
          ),
          chatId: configProps[ConfigProps.HeaderEmbeddedWebChatID],
        },
        () => {
          this.moveChatElement();
        }
      );
    });

    this.navTokenSub = NavigationTokensService.get([
      NavigationTokens.customerService,
    ]).subscribe((navTokens) => {
      this.setState({
        navTokens: navTokens,
      });
    });
  }

  render() {
    return (
      <>
        <div className="row need-help">
          <div className="col-12">
            <YourRepresentative
              repType={RepTypes.customerService}
              isDesktop={false}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 support-buttons">
            <SupportButton
              icon="call"
              label="Call"
              href={`tel:${this.state.phone}`}
            />
            <SupportButton
              icon="mail"
              label="Email"
              href={`${this.state.navTokens[NavigationTokens.customerService]}?cntp=0`}
            />
            <div
              id={liveChatPortalId}
              className="d-inline-block d-inline-block align-top"
            ></div>
          </div>
        </div>
      </>
    );
  }
}

export default NeedHelp;
